/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { Employee, RouteParams } from "~/models";
import { personToDropdown, useAxios } from "~/tools";

const useCustomerEmployees = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchEmployees = useCallback(async () => {
    try {
      const { data } = await Axios().get(`/customers/${customerId}/employees`);
      setEmployees(data.employees || []);
    } catch (e) {
      showError(e.response);
    }
  }, [Axios, showError, customerId, setEmployees]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return {
    employees: employees.map(personToDropdown),
  };
};

export { useCustomerEmployees };
